const actions = {
  AUTHORIZE_CODE_2FA: 'AUTHORIZE_CODE_2FA',
  AUTHORIZE_CODE_2FA_SUCCESS: 'AUTHORIZE_CODE_2FA_SUCCESS',
  AUTHORIZE_CODE_2FA_FAILURE: 'AUTHORIZE_CODE_2FA_FAILURE',

  GET_USER_DATA: 'GET_USER_DATA',
  GET_USER_DATA_SUCCESS: 'GET_USER_DATA_SUCCESS',
  GET_USER_DATA_FAILURE: 'GET_USER_DATA_FAILURE',

  TWO_FA_AUTHORIZATION_MODAL: 'TWO_FA_AUTHORIZATION_MODAL',
}

export default actions

export const validateOtp = values => {
  return {
    type: actions.AUTHORIZE_CODE_2FA,
    values,
  }
}

export const getUserData = (email, token) => {
  return {
    type: actions.GET_USER_DATA,
    email,
    token,
  }
}

export const twoFAauthorizationModal = value => {
  return {
    type: actions.TWO_FA_AUTHORIZATION_MODAL,
    value,
  }
}
